(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
(function (global) {
  'use strict';
  var nextId = 0;
  function mount(root, options) {
    var o = options || {}, lib = o.library || global.StikkmaMotifs;
    if (!root || !root.ownerDocument || !lib || !lib.loaded) throw new TypeError('A root element and a loaded motif library are required');
    var doc = root.ownerDocument, win = doc.defaultView;
    var tools = global.StikkmaMotifTools, styles = tools.styles;
    var id = 'stikkma-motifs-' + (++nextId);
    var selection = lib.selection('none', 'nordic');
    if (o.selection && lib.get(o.selection.motifId)) selection = lib.selection(o.selection.motifId, o.selection.motifStyle || 'nordic');
    var draft = selection, query = '', category = 'all', page = 0;
    var generation = 0, summaryGeneration = 0, observer = null, destroyed = false;
    var readyDraft = 'none', issue = '';
    var controller = new win.AbortController();
    var signal = controller.signal;
    function el(tag, cls, text) {
      var node = doc.createElement(tag);
      if (cls) node.className = cls;
      if (text !== undefined) node.textContent = text;
      return node;
    }
    function on(node, type, listener) { node.addEventListener(type, listener, {signal: signal}); }
    function button(cls, text) { var b = el('button', cls, text); b.type = 'button'; return b; }
    function add(parent) {
      Array.prototype.slice.call(arguments, 1).forEach(function (child) { parent.appendChild(child); });
      return parent;
    }
    root.classList.add('stikkma-motif-picker');
    var summary = el('div', 'stikkma-motif-summary');
    var summaryCanvas = el('canvas'); summaryCanvas.width = 132; summaryCanvas.height = 132;
    summaryCanvas.setAttribute('aria-hidden', 'true');
    var copy = el('div', 'stikkma-motif-summary-copy');
    var selectedName = el('strong'), selectedStyle = el('small');
    var actions = el('div', 'stikkma-motif-actions');
    var openButton = button('stikkma-motif-open', 'Motiv wählen');
    var removeButton = button('stikkma-motif-remove', 'Entfernen');
    add(copy, selectedName, selectedStyle); add(actions, openButton, removeButton);
    add(summary, summaryCanvas, copy, actions);
    var dialog = el('dialog', 'stikkma-motif-dialog');
    dialog.setAttribute('aria-labelledby', id + '-title');
    dialog.setAttribute('aria-describedby', id + '-intro');
    var shell = el('div', 'stikkma-motif-shell');
    var header = el('header', 'stikkma-motif-header');
    var headingRow = el('div', 'stikkma-motif-heading-row');
    var headingCopy = el('div'), title = el('h2', '', 'Dein Motiv');
    title.id = id + '-title';
    var intro = el('p', '', 'Entdecke ein Thema oder suche direkt nach deinem Lieblingsmotiv.');
    intro.id = id + '-intro';
    var closeButton = button('stikkma-motif-close', '×');
    closeButton.setAttribute('aria-label', 'Motivauswahl schließen');closeButton.autofocus=true;
    add(headingCopy, title, intro); add(headingRow, headingCopy, closeButton);
    var filters = el('div', 'stikkma-motif-filters');
    var searchLabel = el('label', '', 'Motiv suchen');
    var search = el('input'); search.type = 'search'; search.placeholder = 'Motiv suchen';
    search.autocomplete = 'off'; search.id = id + '-search';
    searchLabel.htmlFor = search.id; add(searchLabel, search);
    var categoryLabel = el('label', '', 'Thema');
    var categorySelect = el('select'); categorySelect.id = id + '-category';
    categoryLabel.htmlFor = categorySelect.id;
    var all = el('option', '', 'Alle Themen (' + lib.motifs.length + ')'); all.value = 'all'; categorySelect.appendChild(all);
    lib.categories.forEach(function (c) {
      if (!c.count) return;
      var option = el('option', '', c.label + ' (' + c.count + ')'); option.value = c.id; categorySelect.appendChild(option);
    });
    add(categoryLabel, categorySelect); add(filters, searchLabel, categoryLabel);
    var styleGroup = el('fieldset', 'stikkma-motif-style');
    styleGroup.appendChild(el('legend', '', 'Motivstil'));
    var styleInputs = {};
    Object.keys(styles).forEach(function (style) {
      var label = el('label'), input = el('input'), span = el('span', '', styles[style]);
      input.type = 'radio'; input.name = id + '-style'; input.value = style;
      styleInputs[style] = input; add(label, input, span); styleGroup.appendChild(label);
      on(input, 'change', function () {
        if (!input.checked) return;
        draft = lib.selection(draft.motifId, style);
        readyDraft = draft.motifId === 'none' ? 'none' : '';
        renderResults(); prepareDraft();
      });
    });
    add(header, headingRow, filters, styleGroup);
    var scroll = el('div', 'stikkma-motif-scroll');
    var results = el('p', 'stikkma-motif-results');
    results.setAttribute('role', 'status'); results.setAttribute('aria-live', 'polite');
    var grid = el('ul', 'stikkma-motif-grid'); grid.setAttribute('aria-label', 'Motive');
    var empty = el('div', 'stikkma-motif-empty');
    add(empty, el('strong', '', 'Noch kein passendes Motiv gefunden.'), el('p', '', 'Versuche einen kürzeren Suchbegriff oder wähle ein anderes Thema.'));
    var pagination = el('nav', 'stikkma-motif-pagination'); pagination.setAttribute('aria-label', 'Weitere Motive');
    var previous = button('', 'Zurück'), pageLabel = el('span'), next = button('', 'Weiter');
    add(pagination, previous, pageLabel, next); add(scroll, results, grid, empty, pagination);
    var footer = el('footer', 'stikkma-motif-footer');
    var footerCopy = el('div', 'stikkma-motif-footer-selection');
    var draftName = el('strong'), draftStyle = el('small');
    draftStyle.setAttribute('aria-live', 'polite');
    var footerActions = el('div', 'stikkma-motif-footer-actions');
    var noneButton = button('stikkma-motif-none', 'Ohne Motiv');
    var apply = button('stikkma-motif-apply', 'Motiv übernehmen');
    add(footerCopy, draftName, draftStyle); add(footerActions, noneButton, apply); add(footer, footerCopy, footerActions);
    add(shell, header, scroll, footer); dialog.appendChild(shell); root.replaceChildren(summary, dialog);
    function clear(canvas) { canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height); }
    function name(s) { return s.motifId === 'none' ? 'Ohne Motiv' : lib.get(s.motifId).label; }
    function setPressed() {
      grid.querySelectorAll('[data-motif-id]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.motifId === draft.motifId)); });
    }
    function renderFooter() {
      draftName.textContent = name(draft);
      draftStyle.textContent = issue || (draft.motifId === 'none' ? 'Dein Text und deine weiteren Einstellungen bleiben erhalten.' : styles[draft.motifStyle]);
      apply.textContent = draft.motifId === 'none' ? 'Ohne Motiv weiter' : 'Motiv übernehmen';
      apply.disabled = draft.motifId !== 'none' && readyDraft !== draft.motifId + '/' + draft.motifStyle;
    }
    async function prepareDraft() {
      issue = ''; renderFooter();
      if (draft.motifId === 'none') return;
      var requested = draft.motifId + '/' + draft.motifStyle;
      try {
        await lib.prepare(draft.motifId, draft.motifStyle);
        if (draft.motifId + '/' + draft.motifStyle !== requested || destroyed) return;
        readyDraft = requested;
      } catch (_) {
        if (draft.motifId + '/' + draft.motifStyle !== requested || destroyed) return;
        issue = 'Dieses Motiv kann gerade nicht geladen werden. Bitte wähle es erneut.';
      }
      renderFooter();
    }
    async function renderSummary() {
      var token = ++summaryGeneration, s = selection;
      selectedName.textContent = name(s);
      selectedStyle.textContent = s.motifId === 'none' ? 'Optional: dein Motiv – mit oder ohne Text.' : styles[s.motifStyle];
      openButton.textContent = s.motifId === 'none' ? 'Motiv wählen' : 'Ändern';
      removeButton.hidden = s.motifId === 'none'; summaryCanvas.hidden = s.motifId === 'none';
      clear(summaryCanvas);
      if (s.motifId === 'none') return;
      try {
        await lib.prepare(s.motifId, s.motifStyle);
        if (token !== summaryGeneration || destroyed) return;
        lib.draw(summaryCanvas.getContext('2d'), s.motifId, s.motifStyle, {x: 10, y: 10, w: 112, h: 112});
      } catch (_) { if (token === summaryGeneration) selectedStyle.textContent = styles[s.motifStyle] + ' · Vorschau gerade nicht verfügbar'; }
    }
    function commit(s, reason) {
      var before = selection;
      selection = lib.selection(s.motifId, s.motifStyle);
      renderSummary();
      var detail = Object.assign({}, selection, {reason: reason, previousMotifId: before.motifId});
      if (typeof o.onChange === 'function') o.onChange(detail);
      win.dispatchEvent(new win.CustomEvent('cusco-motif-change', {detail: detail}));
    }
    async function paintCard(canvas, status, motif, style, token) {
      if (canvas.dataset.started === 'true') return;
      canvas.dataset.started = 'true';
      try {
        await lib.prepare(motif.id, style);
        if (token !== generation || destroyed || !canvas.isConnected) return;
        clear(canvas);
        lib.draw(canvas.getContext('2d'), motif.id, style, {x: 18, y: 18, w: 244, h: 244});
        status.textContent = '';
      } catch (_) { if (token === generation) status.textContent = 'Vorschau erneut laden'; }
    }
    function renderResults() {
      var token = ++generation;
      if (observer) observer.disconnect();
      var found = lib.search(query, category), paged = tools.paginate(found, page, o.pageSize || 12);
      page = paged.page;
      results.textContent = paged.total + (paged.total === 1 ? ' Motiv' : ' Motive') +
        (query.trim() ? ' für „' + query.trim() + '“' : '') +
        (paged.total ? ' · ' + (page * paged.pageSize + 1) + '–' + Math.min(paged.total, (page + 1) * paged.pageSize) : '');
      empty.hidden = !!paged.total; grid.hidden = !paged.total; pagination.hidden = paged.pageCount <= 1;
      previous.disabled = page === 0; next.disabled = page === paged.pageCount - 1;
      pageLabel.textContent = (page + 1) + ' / ' + paged.pageCount;
      grid.replaceChildren();
      var jobs = new Map();
      paged.items.forEach(function (motif) {
        var li = el('li'), card = button('stikkma-motif-card', '');
        card.dataset.motifId = motif.id; card.setAttribute('aria-pressed', String(motif.id === draft.motifId));
        var canvas = el('canvas'); canvas.width = 280; canvas.height = 280;
        canvas.setAttribute('aria-hidden', 'true');
        var label = el('span', 'stikkma-motif-card-name', motif.label);
        var status = el('span', 'stikkma-motif-card-status', 'Vorschau wird geladen');
        card.setAttribute('aria-label', motif.label + ', ' + styles[draft.motifStyle]);
        add(card, canvas, label, status); li.appendChild(card); grid.appendChild(li);
        jobs.set(canvas, function () { paintCard(canvas, status, motif, draft.motifStyle, token); });
        on(card, 'click', function () {
          draft = lib.selection(motif.id, draft.motifStyle);
          readyDraft = ''; issue = '';
          if (status.textContent === 'Vorschau erneut laden') { canvas.dataset.started = ''; paintCard(canvas, status, motif, draft.motifStyle, generation); }
          setPressed(); prepareDraft();
        });
      });
      if (win.IntersectionObserver) {
        observer = new win.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { var job = jobs.get(entry.target); if (job) job(); observer.unobserve(entry.target); }
          });
        }, {root: scroll, rootMargin: '120px'});
        jobs.forEach(function (_, canvas) { observer.observe(canvas); });
      } else { jobs.forEach(function (job) { job(); }); }
      Object.keys(styleInputs).forEach(function (style) { styleInputs[style].checked = draft.motifStyle === style; });
      renderFooter();
    }
    function close() { if (dialog.open) dialog.close(); }
    function open() {
      draft = selection; readyDraft = draft.motifId === 'none' ? 'none' : '';
      issue = ''; search.value = query; categorySelect.value = category;
      dialog.showModal(); renderResults(); prepareDraft();
      closeButton.focus({preventScroll:true});
    }
    on(openButton, 'click', open);
    on(closeButton, 'click', close);
    on(dialog, 'close', function () { if (observer) observer.disconnect(); generation++; openButton.focus(); });
    on(dialog, 'click', function (e) {
      if (e.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (e.clientX < bounds.left || e.clientX > bounds.right || e.clientY < bounds.top || e.clientY > bounds.bottom) close();
    });
    on(removeButton, 'click', function () { commit(lib.selection('none', selection.motifStyle), 'clear'); });
    on(noneButton, 'click', function () { draft = lib.selection('none', draft.motifStyle); readyDraft = 'none'; issue = ''; setPressed(); renderFooter(); });
    on(apply, 'click', function () {
      if (apply.disabled) return;
      var reason = draft.motifId === 'none' ? 'clear' : draft.motifId === selection.motifId ? 'style' : 'select';
      commit(draft, reason); close();
    });
    on(search, 'input', function () { query = search.value; page = 0; renderResults(); scroll.scrollTop = 0; });
    on(categorySelect, 'change', function () { category = categorySelect.value; page = 0; renderResults(); scroll.scrollTop = 0; });
    on(previous, 'click', function () { page--; renderResults(); scroll.scrollTop = 0; });
    on(next, 'click', function () { page++; renderResults(); scroll.scrollTop = 0; });
    on(grid, 'keydown', function (event) {
      var b = event.target.closest('[data-motif-id]'); if (!b) return;
      var buttons = Array.from(grid.querySelectorAll('[data-motif-id]')), index = buttons.indexOf(b);
      var columns = win.getComputedStyle(grid).gridTemplateColumns.trim().split(/\s+/).length;
      var moves = {ArrowLeft: -1, ArrowRight: 1, ArrowUp: -columns, ArrowDown: columns};
      var target = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 :
        Object.prototype.hasOwnProperty.call(moves, event.key) ? Math.max(0, Math.min(buttons.length - 1, index + moves[event.key])) : -1;
      if (target >= 0) { event.preventDefault(); buttons[target].focus(); }
    });
    renderSummary();
    return {
      open: open, close: close,
      getSelection: function () { return Object.assign({}, selection); },
      setSelection: function (value, notify) {
        selection = lib.selection(value.motifId, value.motifStyle || 'nordic');
        if (notify) commit(selection, 'external'); else renderSummary();
      },
      destroy: function () {
        destroyed = true; if (observer) observer.disconnect(); if (dialog.open) dialog.close();
        controller.abort(); root.replaceChildren();
      }
    };
  }
  global.StikkmaMotifPicker = {mount: mount};
})(typeof window !== 'undefined' ? window : globalThis);

})();
